import React from 'react';
import {
  Card, Rating, CardHeader, IconButton, Stack, Typography,
} from '@mui/material';
import { OutlinedIcons, convertRatingPercentageToNumber } from '@marageti/z4-lib';
import { Link } from 'react-router-dom';
import { Review, ReviewStatus } from '@marageti/z4-sdk/lib/travel';

const ReviewCard = ({ review }: { review: Review }) => {
  const isReviewPending = review.status === ReviewStatus.ReviewStatusPending;
  const numberOfStars = convertRatingPercentageToNumber(review.rating);

  // Incoming trip matches will have an empty review object with a status of ReviewStatus.ReviewStatusPending.
  // We only want to show the review card if the review is either a draft or has been submitted.
  // Because of this we need to check the presence of a rating to determine if the user has already "drafted" the review themselves.
  // If there is no rating, we don't want to show the card.
  if (!review.rating) {
    return null;
  }

  return (
    <Card
      component={Link}
      to={isReviewPending ? `/trip-matches/${review.tripMatchId}/review` : `/reviews/${review.id}`}
      sx={{
        textDecoration: 'none',
      }}
    >
      <CardHeader
        title={(
          <Stack direction="row" spacing={1}>
            <Typography variant="bodyBold">
              Your Review
            </Typography>
            {isReviewPending && <Typography variant="bodyItalic" component="span">Draft</Typography>}
          </Stack>
        )}
        disableTypography
        subheader={(
          <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 1 }}>
            <Rating name="read-only" value={numberOfStars} readOnly size="small" />
            <Typography variant="caption" color="primary">{`${numberOfStars}/5`}</Typography>
          </Stack>
        )}
        action={(
          <IconButton disabled>
            <OutlinedIcons.OutlinedChevronRightIcon color="primary" />
          </IconButton>
        )}
        sx={{
          '& .MuiCardHeader-action': {
            alignSelf: 'center',
          },
        }}
      />
    </Card>
  );
};

export default ReviewCard;
